import React from 'react';

import { CarsparencyLogoSvg } from '../../svg';
import { Button } from '../../ui';

export const ServerErrorPage: React.FC = () => {
  const refresh_page = () => {
    location.href = '/';
  };
  const contact_support = () => {
    window.open(`tel:+971545998124`);
  };

  return (
    <div className="tw-flex tw-flex-col tw-justify-center tw-h-screen tw-p-[16px] md:tw-items-center lg:tw-p-[130px]">
      <div className="tw-flex tw-flex-col tw-justify-center md:tw-items-center">
        <div
          className={
            'tw-flex tw-flex-col tw-justify-center tw-items-center tw-mb-[24px] md:tw-mb-[32px] lg:tw-flex-row-reverse tw-max-w-[1400px]'
          }
        >
          <CarsparencyLogoSvg
            className={'tw-h-[120px] tw-w-[244px] tw-absolute tw-top-[40px] lg:tw-hidden'}
          />
          <h1 className="tw-text-[110px] md:tw-text-[200px] tw-font-bold tw-leading-[110px] md:tw-leading-normal tw-text-center tw-text-gray0 lg:tw-flex-1 lg:-tw-mb-16">
            500
          </h1>
          <div className={'tw-flex tw-flex-col tw-items-center lg:tw-items-start lg:tw-flex-1'}>
            <CarsparencyLogoSvg className={'tw-h-[120px] tw-w-[244px] tw-hidden lg:tw-flex'} />
            <p className="tw-text-[18px] md:tw-text-[20px] lg:tw-text-[24px] tw-text-gray300">
              Internal Server Error
            </p>
            <h4 className="tw-text-[24px] md:tw-text-[32px] lg:tw-text-[48px] tw-text-gray0 tw-mt-[16px] tw-text-center lg:tw-text-start tw-whitespace-pre-line md:tw-whitespace-normal">
              {"We're fixing it. Please try again\nlater or contact support!"}
            </h4>
          </div>
        </div>
        <div className={'tw-self-center lg:tw-self-start tw-flex tw-gap-[20px]'}>
          <Button size={'large'} color={'gray'} onClick={refresh_page}>
            {'Refresh The Page'}
          </Button>
          <div className={'tw-hidden lg:tw-flex'}>
            <Button size={'large'} color={'gray'} onClick={contact_support}>
              {'Contact Support'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
